export default __webpack_public_path__ + "static/media/26.be4d7528.jpg";